import axios, { AxiosResponse } from 'axios'
import { FETCH_STAFF_ENDPOINT } from 'constants/urls'

// 未認証でも招待の有効期限を確認したいのでCloud Functions経由で招待の状態を取得する
// 招待が見つからない・使用済みの場合も、期限切れと同じく招待を使えないものとして扱う
const getIsInvitationExpired = async (token: string): Promise<boolean> => {
  try {
    const res: AxiosResponse = await axios.post(
      FETCH_STAFF_ENDPOINT,
      { token },
      {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    return res.data.expired !== false
  } catch (e) {
    console.error(e)
    return true
  }
}

export default getIsInvitationExpired
